
import InnerPageTitle from '@/components/Shared/InnerPageTitle/index.vue'
import BookImage from './BookImage.vue'
import BookDescription from './BookDescription.vue'
import BookComments from './BookComments.vue'
import BookOverview from './BookOverview.vue'
import InnerSearch from '@/components/Shared/Search/InnerSearch.vue'
import BookCategories from './BookCategories.vue'
import BookMostPopularProducts from './BookMostPopularProducts.vue'
import BookTags from './BookTags.vue'
import BookTabs from './BookTabs.vue'
import SimilarProducts from '../SimilarProducts/index.vue'
import ExamList from '@/components/ExamList/index.vue'
import ProductSubscription from '../ProductSubscription/index.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    InnerPageTitle,
    BookImage,
    BookDescription,
    BookComments,
    BookOverview,
    InnerSearch,
    BookCategories,
    BookMostPopularProducts,
    BookTags,
    BookTabs,
    SimilarProducts,
    ExamList,
    ProductSubscription,
  },
  data() {
    return {
      tab: 'BookOverview',
      subscriptions: [],
      productInfo: null,
      isLoading: false,
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
      getUserProducts: 'user/getUserProducts',
      getUserSubscriptions: 'user/getUserSubscriptions',
    }),
    canUserBuyWithSubscription() {
      return this.getUserProducts?.some(
        (product) => product.id === this.product.id
      )
    },
  },
  props: {
    product: {
      default: () => {},
    },
  },
  methods: {
    async fetchSubscriptions(productId) {
      if (!this.getActiveUser.token) return
      this.isLoading = true
      this.errorMessage = ''

      try {
        const response = await this.$api.get(
          `Subscription/GetSubscriptionsByProduct/${productId}`
        )
        const payload = response?.data ?? response
        const data = payload?.data || payload

        const items = data?.subscriptionPackages || []
        this.productInfo = data?.product || null

        this.subscriptions = Array.isArray(items) ? items : []
      } catch (error) {
        this.errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          this.$custom$t('productSubscription.error')
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    if (this.product?.id) {
      this.fetchSubscriptions(this.product.id)
    }
  },
}
